<template>
  <div class="sub_card">
    <div class="sub_flex">
      <figcaption class="sub_content">
          <h3 class="sub_title">{{subscription.area.display_name}}</h3>
          <p class="sub_status" :class="{'expired': subscription.isExpired === true}">
            <img :src="subIcon" alt="subscription_icon" class="sub_icon">
            {{ subStatusText }}
          </p>
          <!-- <p class="sub_status expired">
            <img src="@/assets/images/icon_info_s_red.png" alt="subscription_icon" class="sub_icon">
            授權已到期
          </p> -->
      </figcaption>
      <figure class="sub_img">
          <img v-bind:src="subscription.area.imgCover">
      </figure>
    </div>
    <b class="sub_time">從 {{ subLastTime }} 開始訂閱</b>
    <!-- <router-link v-bind:to="subscription.url" class="fullLink"></router-link> -->
  </div>
</template>

<script>
import { parseDate } from '@/utils/parseTime'
import subscriptionIcon from '@/assets/images/icon_subscription_yellow.png'
import expiredSubscriptionIcon from '@/assets/images/icon_info_s_red.png'

export default {
  name: 'SubscriptionCard',
  props: {
    subscription: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      successStatusCode: [1000, 7000, 8000]
    }
  },
//   filters: {
//     pointReset: function (value) {
//       return value < 0 ? 0 : value
//     }
//   },
  computed: {
    subLastTime () {
      return parseDate(this.subscription.created_at)
    },
    subIcon () {
      return this.subscription.isExpired ? expiredSubscriptionIcon : subscriptionIcon
    },
    subStatusText () {
      return this.subscription.isExpired ? '授權已到期' : '訂閱中'
    }
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
  .sub_card {
    min-height: 180px;
  }
  .sub_flex {
    display: flex;
    justify-content: space-between;
    // margin-bottom: 50px;
  }
  .sub_content {
    margin-right: 15px;
    flex: 1 1 auto;
    position: relative;
  }
  .sub_title {
    font-size: 22px;
    line-height: 31px;
    font-weight: 600;
    margin-bottom: 10px;
    padding-top: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .sub_status {
    font-size: 14px;
    line-height: 20px;
    font-weight: 600;
    color: rgb(246,140,4);
    display: flex;
    align-items: center;
    position: absolute;
    bottom: -32px;
    left: 0;
    &.expired {
      color: rgb(208, 2, 27);
    }
    .sub_icon {
      width: 14px;
      margin-right: 6px;
    }
  }
  .sub_time {
    font-size: 14px;
    line-height: 20px;
    color: rgba(0,0,0,0.5);
    position: absolute;
    bottom: 24px;
    left: 24px;
  }
  .sub_img {
    flex: 0 0 100px;
    width: 100px;
    img {
      border-radius: 6px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/views/mySubviews/MySubscription/components/SubscriptionCard.vue